import type { AmplitudeEventKeys } from '../../amplitude-properties.types';
import { getEventPropsBuilder } from '../../utils';

type SwjCtaClickedEvent = {
    linkUrl: string;
};

export const getSwjCtaClickedProps = getEventPropsBuilder(
    (event: SwjCtaClickedEvent): Partial<AmplitudeEventKeys> => ({
        event: 'FDC Jackpots Module CTA Clicked',
        Module: 'fdc_jackpots',
        'Page Name': 'home',
        'Link Text': 'view_all',
        'Link URL': event.linkUrl
    })
);
